import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=474842f4&scoped=true"
import script from "./sign-up.vue?vue&type=script&lang=ts"
export * from "./sign-up.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474842f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474842f4')) {
      api.createRecord('474842f4', component.options)
    } else {
      api.reload('474842f4', component.options)
    }
    module.hot.accept("./sign-up.vue?vue&type=template&id=474842f4&scoped=true", function () {
      api.rerender('474842f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application-widget/welcome/sign-up.vue"
export default component.exports